import { ofType } from "redux-observable";
import { map, switchMap } from "rxjs/operators";
import JobProApi from "../../dependencies/JobProApi";

// Action types
export const FETCH_ITEM_TYPES = "FETCH_ITEM_TYPES";
export const FETCH_ITEM_TYPES_COMPLETE = "FETCH_ITEM_TYPES_COMPLETE";

const DEFAULT_STATE = {
  itemTypes: [],
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_ITEM_TYPES_COMPLETE:
      return {
        ...state,
        itemTypes: payload,
      };
    default:
      return state;
  }
}

// Action creators
export const fetchItemTypes = () => ({
  type: FETCH_ITEM_TYPES,
});

export const fetchItemTypesComplete = (itemTypes) => ({
  type: FETCH_ITEM_TYPES_COMPLETE,
  payload: itemTypes,
});

// Epic
export const fetchItemTypesEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_ITEM_TYPES),
    switchMap(() => {
      const itemTypesPromise = JobProApi.items.types.query({
        fields:
          "id,name,quantityLabel,installedQuantityLabel,inventoryQuantityLabel",
      });
      return itemTypesPromise;
    }),
    map((itemTypes) => {
      return fetchItemTypesComplete(itemTypes);
    })
  );
